import request from "../utils/request";

export async function createTarget(newTarget) {
  return request.post("Target/Create", newTarget);
}

export async function deleteTarget(id) {
  return request.delete('Target/Delete?targetId=' + id);
}

export async function getTargetList(payload) {
  return request.get("Target/List", {
    params: {
      productId: payload.product != null ? payload.product.id : null,
      branchId: payload.branch.id,
      personalId: payload.personal != null ? payload.personal.id : null,
      month: payload.month.id,
      year: payload.year,
      kind: kindEngConverter(payload.kind),
      type: typeEngConverter(payload.type)
    }
  });
}

export async function getTargetListForDealer(payload) {
  return request.get("Target/ListForDealer", {
    params: {
      productId: payload.product != null ? payload.product.id : null,
      branchId: payload.branch.id,
      personalId: payload.personal != null ? payload.personal.id : null,
      month: payload.month.id,
      year: payload.year,
      kind: kindEngConverter(payload.kind),
      type: typeEngConverter(payload.type)
    }
  });
}

function kindEngConverter(kind) {
  if (kind == null || typeof kind == "undefined") return null;
  if(kind == "Product" || type == "Giro") return kind;
  let result = null;
  switch (kind) {
    case "Ürün":
      result = "Product";
      break;
    case "Ciro":
      result = "Giro";
      break;
    default:
      result = null;
      break;
  }
  return result;
}

function typeEngConverter(type) {
    if (type == null || typeof type == "undefined") return null;
    if(type == "Personal" || type == "Branch") return type;
    let result = null;
    switch (type) {
      case "Personel":
        result = "Personal";
        break;
      case "Şube":
        result = "Branch";
        break;
      default:
        result = null;
        break;
    }
    return result;
  }
